import { useState, useCallback } from "react";

export const useHistoryVisible = () => {
  const [hasSearchHistory, setHasSearchHistory] = useState<boolean>(false);

  const handleSearchHistory = useCallback((hasHistory: boolean) => {
    setHasSearchHistory(hasHistory);
  }, []);

  return {
    hasSearchHistory,
    handleSearchHistory,
  };
};
